import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideBarComponent } from './side-bar.component';
import { LayerListComponent } from './layer-list/layer-list.component';
import { LegendComponent } from './legend/legend.component';
import { SearchComponent } from './search/search.component';
import { FormsModule } from '@angular/forms';
import { PrinterComponent } from './printer/printer.component';
import { LayoutModule } from '../../../layout/layout.module';
import { SharedMaterialModule } from '../../../shared/material.module';
import { LibModule } from 'lib';

@NgModule({
  declarations: [
    SideBarComponent,
    LayerListComponent,
    LegendComponent,
    SearchComponent,
    PrinterComponent,
    LayerListComponent
  ],
  imports: [
    CommonModule,
    LayoutModule,
    SharedMaterialModule,
    FormsModule,
    LibModule
  ],
  exports: [
    SideBarComponent,
    LayerListComponent,
    LegendComponent,
  ],
})
export class SideBarModule { }
